module.exports = __webpack_public_path__ + "static/media/left-section.f450c2dd.png";